import { useDispatch } from 'react-redux'
import * as actions from '~/redux/actions/product'
import { useMemo } from 'react'
import { bindActionCreators } from 'redux'

export function useProduct() {
  const dispatch = useDispatch()

  const createStockRequest = useMemo(
    () => bindActionCreators(actions.createStockRequest, dispatch),
    [dispatch]
  )

  return {
    createStockRequest
  }
}
